import React, { memo } from 'react';
import { areEqual } from 'Utils/equalityChecks';

import { TabContentHeader } from 'Components/TabContentHeader';
import { ActionsCenter } from 'Containers/RocketScan';

interface Props {
  locationIcon: string;
  locationName: string;
  isAccessible: boolean;
  scopeTotal?: number;
  scopeLabel?: string;
}

const LocationHeader = ({ locationIcon, locationName, isAccessible, scopeTotal, scopeLabel }: Props) => (
  <TabContentHeader
    icon={locationIcon}
    name={locationName}
    isCommercial
    isInaccessible={isAccessible}
    actionsCenter={<ActionsCenter locationType="roomsview" propertyType="multiunit" />}
    hasDivider
    isLocation
    scopeTotal={scopeTotal}
    scopeLabel={scopeLabel}
  />
);

const LocationHeaderMemo = memo(LocationHeader, areEqual);

export { LocationHeaderMemo as LocationHeader };
